import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getIdee, editIdee } from "../../service/api";
import {
  Box,
  Container,
  Heading,
  Input,
  Textarea,
  Text,
  Button,
  VStack,
  HStack,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";

const EditIdee = () => {
  const [idee, setIdee] = useState({
    kurzfassung: "",
    idee: "",
    von: "",
    datum: "",
  });
  const { id } = useParams();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [message, setMessage] = useState("");

  useEffect(() => {
    loadIdeeDetails(id);
  }, [id]);

  const loadIdeeDetails = async (id) => {
    const response = await getIdee(id);
    setIdee(response.data || {});
  };

  const onValueChange = (e) =>
    setIdee({ ...idee, [e.target.name]: e.target.value });

  const updateNewIdee = async () => {
    const response = await editIdee(idee);
    setMessage(response.data?.message || "Änderungen gespeichert!");
    onOpen();
  };

  return (
    <Container maxW="lg" py={{ base: 6, md: 10 }}>
      <Box
        bg="gray.50"
        p={{ base: 6, md: 8 }}
        borderRadius="2xl"
        border="1px solid"
        borderColor="gray.200"
        shadow="md"
      >
        <Heading
          mb={6}
          textAlign="center"
          bgGradient="linear(to-r, teal.500, blue.400)"
          bgClip="text"
          fontSize={{ base: "2xl", md: "3xl" }}
        >
          Idee bearbeiten
        </Heading>

        <VStack spacing={5} align="stretch">
          <Box>
            <Text mb={1} fontWeight="semibold">
              Kurzfassung
            </Text>
            <Input
              name="kurzfassung"
              value={idee.kurzfassung || ""}
              onChange={onValueChange}
              focusBorderColor="teal.400"
              placeholder="Kurzbeschreibung der Idee"
              fontSize={{ base: "sm", md: "md" }}
            />
          </Box>

          <Box>
            <Text mb={1} fontWeight="semibold">
              Idee
            </Text>
            <Textarea
              name="idee"
              value={idee.idee || ""}
              onChange={onValueChange}
              focusBorderColor="teal.400"
              placeholder="Ausführliche Beschreibund der Idee ..."
              resize="vertical"
              minH="120px"
              fontSize={{ base: "sm", md: "md" }}
            />
          </Box>

          <HStack spacing={4} flexWrap="wrap">
            <Box flex="1" minW="48%">
              <Text mb={1} fontWeight="semibold">
                Von
              </Text>
              <Input
                name="von"
                value={idee.von || ""}
                onChange={onValueChange}
                focusBorderColor="teal.400"
                placeholder="Bearbeitet von"
                fontSize={{ base: "sm", md: "md" }}
              />
            </Box>

            <Box flex="1" minW="48%">
              <Text mb={1} fontWeight="semibold">
                Datum
              </Text>
              <Input
                type="date"
                name="datum"
                value={idee.datum || ""}
                onChange={onValueChange}
                focusBorderColor="teal.400"
                fontSize={{ base: "sm", md: "md" }}
              />
            </Box>
          </HStack>

          <HStack spacing={3} justify="space-between" flexWrap="wrap" mt={4}>
            <Button
              variant="primary"
              w={{ base: "100%", sm: "auto" }}
              onClick={updateNewIdee}
            >
              Änderungen speichern
            </Button>

            <Button
              as="a"
              href="/ideen"
              variant="ghostOutline"
              w={{ base: "100%", sm: "auto" }}
            >
              Zurück zur Anzeige
            </Button>
          </HStack>
        </VStack>
      </Box>

      {/* Modal für Statusmeldung */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Rückmeldung</ModalHeader>
          <ModalBody>
            <Text>{message}</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" mr={3} onClick={onClose}>
              Schließen
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Container>
  );
};

export default EditIdee;
